import { createFileRoute } from "@tanstack/react-router"
import { queryClient } from "@/queryClient"
import { getProjectOptions, getProjectReviewSummaryOptions } from "@/client/@tanstack/react-query.gen"
import Project from "@/routes/-pages/Project"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/project/$projectId")({
  loader: ({ params }) => {
    const { projectId } = params
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getProjectOptions({ path: { project_id: projectId } })),
        queryClient.prefetchQuery(getProjectReviewSummaryOptions({ path: { project_id: projectId } })),
      ]),
    )
  },
  component: Project,
})
